'use strict';

import template from './sign_in_form.html';

const controller = [
  'auth',

  function (auth) {
    this.submit = function () {
      this.isLoading = true;
      this.isAuthErrorVisible = false;

      auth.signInWithEmail(this.data)
        .then(function () {
          this.done();
        }.bind(this))
        .catch(function () {
          this.isAuthErrorVisible = true;
        }.bind(this))
        .finally(function () {
          delete this.isLoading;
        }.bind(this));
    };
  }
];
const saSignInForm = [
  function () {
    return {
      template: template,
      replace: true,
      scope: {
        done: '&',
        data: '='
      },
      bindToController: true,
      controllerAs: 'ctrl',
      controller: controller
    };
  }
];

export default saSignInForm;



// WEBPACK FOOTER //
// ./app/src/modules/join/sign_in_form.component.js